import { PolymorphicButtonBase, type PolymorphicButtonBaseProps } from '@plato/ui/primitives/button';
import { cn } from '@plato/ui/util/classes';
import type { ComponentPropsWithRef, ReactElement } from 'react';

export type MessageActionsProps = ComponentPropsWithRef<'div'>;

export function MessageActions({ className, ...props }: MessageActionsProps): ReactElement {
    return (
        <div
            data-slot="message-actions"
            className={cn('flex items-center gap-tight', className)}
            {...props}
        />
    );
}

export type MessageActionButtonProps = PolymorphicButtonBaseProps & {
    /** Names the action for assistive technology, since no text is visible. */
    label: string;
    active?: boolean;
};

export function MessageActionButton({
    active,
    className,
    label,
    ...props
}: MessageActionButtonProps): ReactElement {
    return (
        <PolymorphicButtonBase
            data-slot="message-action-button"
            data-state={active === true ? 'active' : 'inactive'}
            aria-label={label}
            aria-pressed={active}
            className={cn(
                'inline-flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-default',
                'transition duration-state ease-state active:translate-px',
                'state-disabled:pointer-events-none state-disabled:opacity-disabled',
                'text-content-weak hover:bg-content/(--opacity-wash) hover:text-content',
                'data-[state=active]:bg-brand/(--opacity-wash) data-[state=active]:text-brand',
                'hover:data-[state=active]:bg-brand/(--opacity-wash-hover)',
                "*:[svg:not([class*='size-'])]:size-3.5",
                className,
            )}
            {...props}
        />
    );
}
